import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Bookings from './pages/Bookings'
import Services from './pages/Services'
import Customers from './pages/Customers'
import GiftCards from './pages/GiftCards'
import Settings from './pages/Settings'
import ManualPayments from './pages/ManualPayments'
import Messaging from './pages/Messaging'
import Gallery from './pages/Gallery'
import Blog from './pages/Blog'
import HelpCenter from './pages/HelpCenter'
import InstallAppPrompt from './components/InstallAppPrompt'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout pageTitle="Dashboard"><Dashboard /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/bookings" element={
          <ProtectedRoute>
            <Layout pageTitle="Bookings Management"><Bookings /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/services" element={
          <ProtectedRoute>
            <Layout pageTitle="Services Management"><Services /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/customers" element={
          <ProtectedRoute>
            <Layout pageTitle="Customer Management"><Customers /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/gift-cards" element={
          <ProtectedRoute>
            <Layout pageTitle="Gift Cards"><GiftCards /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Layout pageTitle="Settings"><Settings /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/manual-payments" element={
          <ProtectedRoute>
            <Layout pageTitle="Manual Payments"><ManualPayments /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/messaging" element={
          <ProtectedRoute>
            <Layout pageTitle="Messaging & Links"><Messaging /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/gallery" element={
          <ProtectedRoute>
            <Layout pageTitle="Gallery Management"><Gallery /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/blog" element={
          <ProtectedRoute>
            <Layout pageTitle="Blog Management"><Blog /></Layout>
          </ProtectedRoute>
        } />
        <Route path="/help-center" element={
          <ProtectedRoute>
            <Layout pageTitle="Help Center"><HelpCenter /></Layout>
          </ProtectedRoute>
        } />
      </Routes>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#ffffff',
            color: '#374151',
            border: '1px solid #e5e7eb',
          },
        }}
      />
      <InstallAppPrompt />
    </AuthProvider>
  )
}

export default App
